module.exports = __webpack_public_path__ + "images/emoji/ramen.a1f9d7740eaea8da0535.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ramen.png
// module id = 1ITm
// module chunks = 14